module.exports = __webpack_public_path__ + "static/image5-91cfbdda71d605be1b976ee1f83a96d2.jpg";